import * as React from 'react';
import { Modal } from 'antd';
import { PackageProcessingResult } from '../types/PackageProcessingResult';

export const showDocumentProcessingResults = (results: PackageProcessingResult[]) => {
    Modal.info({
        title: 'Document processing requests',
        width: 720,
        content: (
            <div>
                <p>
                    Started: {results.filter(result => result.status === 'Started').length}. Skipped:{' '}
                    {results.filter(result => result.status === 'Skipped').length}. Unconfirmed:{' '}
                    {results.filter(result => result.status === 'Unconfirmed').length}.
                </p>
                <ul>
                    {results.map(result => (
                        <li key={result.packageId}>
                            <strong>{result.fileName || result.packageId}</strong>
                            <div>
                                {result.status === 'Started'
                                    ? result.stage === 'Preparation'
                                        ? 'Reparsing started.'
                                        : 'Reprocessing started.'
                                    : result.status === 'Skipped'
                                      ? 'Skipped.'
                                      : 'Outcome unconfirmed.'}
                            </div>
                            {result.reason && <p>{result.reason}</p>}
                        </li>
                    ))}
                </ul>
            </div>
        )
    });
};
